import { bind, Component, h, tag } from "omi";

import { NWButton, NWTooltip, openModal } from "@/components";
import { Store } from "@/store";
import { tailwind } from "@/tailwind";

import style from "./style.css?inline";

export const enum MissionButtonState {
  Disabled = "DISABLED",
  Enabled = "ENABLED",
  Complete = "COMPLETE",
  CompleteWithReview = "COMPLETE_WITH_REVIEW",
}

type Props = {
  state: MissionButtonState;
  isLoading: boolean;
  onClick: () => void;
  hasValidations?: boolean;
  disabledTooltip: string;
};

@tag("nw-mission-btn")
export class NWMissionBtn extends Component<Props> {
  static css = [tailwind, style];
  static propTypes = {
    state: String,
    hasValidations: Boolean,
    onClick: Function,
    disabledTooltip: String,
    isLoading: Boolean,
  };

  @bind
  handleCompleteOnClick() {
    if (this.props.state === MissionButtonState.Complete && this.props.hasValidations) {
      openModal("share", {
        projectId: Store.project.id.value!,
        linkedInPostData: Store.project.metadata.value?.sharetemplate,
      });
    }
  }

  render({ state, hasValidations = false, isLoading = false }: Props) {
    if (state === MissionButtonState.Complete) {
      return (
        <div class="rainbow-border-wrapper animate-fadeInFast">
          <div class="rainbow-border-content">
            <div className="p-16 flex w-full flex-1 flex-col bg-gray-50 rounded-2xl justify-start items-center gap-8">
              <div className="flex-col justify-start items-center gap-5 flex">
                <h3 className="self-stretch text-center text-primary text-3xl font-semibold">👏 All done!</h3>
                <p className="self-stretch text-center text-tertiary text-lg leading-7 max-w-md">
                  {hasValidations
                    ? "Another epic project complete. We’ll keep your documentation here for whenever you need it."
                    : "You've completed all the tasks! Great job!"}
                </p>
              </div>

              {hasValidations && (
                <NWButton size="fit" type="secondary" onClick={this.handleCompleteOnClick}>
                  View Documentation
                </NWButton>
              )}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div class="w-full flex items-center justify-center">
        {hasValidations ? (
          <NWTooltip
            placement="bottom"
            content={this.props.disabledTooltip}
            shouldShow={state === MissionButtonState.Disabled}
          >
            <NWButton
              loading={isLoading}
              icon={state !== MissionButtonState.Disabled ? "rocket" : undefined}
              disabled={state === MissionButtonState.Disabled}
              class="w-full"
              size="xl"
            >
              {state === MissionButtonState.Disabled ? "Still tasks to complete!" : "Mission accomplished"}
            </NWButton>
          </NWTooltip>
        ) : (
          <NWButton
            loading={isLoading}
            icon={state !== MissionButtonState.Disabled ? "rocket" : undefined}
            disabled={state === MissionButtonState.Disabled}
            class="w-full"
            size="xl"
            withConfetti={true}
          >
            {state === MissionButtonState.Disabled ? "Still tasks to complete!" : "Mission accomplished"}
          </NWButton>
        )}
      </div>
    );
  }
}
